import React, { useState } from 'react';
import { Dropdown, Layout, Tag } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useGlobalState } from '../../../store/state';
import { AiOutlineUser } from 'react-icons/ai';
import { IoIosHelpBuoy, IoMdListBox } from 'react-icons/io';
import { IoLogOutOutline, IoNotificationsOutline } from 'react-icons/io5';
import { AppLogout } from '../../../utils/AppLogout';
import ProfileComponent from './ProfileComponent';
// import './TopHeaderComponent.styles.scss';
import { BsInfoCircle } from 'react-icons/bs';

const { Header } = Layout;
const TopHeaderComponent = ({ layoutControl, toggle }) => {
  const [user] = useGlobalState('user');
  const [profDraw, setProfDraw] = useState(false);

  const showDraw = (e) =>{
    e.preventDefault();
    setProfDraw(true);
  };
  const hideDraw = () =>{
    setProfDraw(false);
  };
  // const [prof]
  const menuUserDropdown = (
    <div className="header_user_dropdown">
      <div className="header_user_dropdown_details d-flex align-items-center">
        <div className="header_user_dropdown_details--avatar">
          <img src={user.profilepicture}
            className="img-fluid"
            alt={user.firstname} />
        </div>
        <div className="header_user_dropdown_details--name">
          <h5>{user.firstname + ' ' + user.lastname}</h5>
          <a href="#"
            onClick={showDraw}>Edit Profile</a>
        </div>
      </div>
      <div className="header_user_dropdown_links">
        {/* <a href="#"><IoIosHelpBuoy size={20}/> Help & Support</a>
                <a href="#"><IoMdListBox size={20}/> Terms & Conditions</a> */}
        <a href="https://flynt.social/privacy.php"
          target="_blank"
          rel="noreferrer"><IoIosHelpBuoy size={20}/> Privacy Policy</a>
        <a href="https://flynt.social/terms-and-conditions.php"
          target="_blank"
          rel="noreferrer"><IoMdListBox size={20}/> Terms &amp; Conditions</a>
        <a href="#"
          onClick={AppLogout}><IoLogOutOutline size={20}/> Logout</a>
      </div>
    </div>
  );
  const menuNotificationDropdown = (
    <div className="header_notify_dropdown">
      <h3 className="header_notify_dropdown--title">Notifications</h3>
      <Scrollbars style={{ height: 300 }}>
        <ul className="header_notify_dropdown_list">
          <li className="header_notify_dropdown_list_each d-flex align-items-center">
            <div className="header_notify_dropdown_list_each--logo">
              <img src="/images/brand-logo.svg"
                className="img-fluid"
                alt="Nike" />
            </div>
            <div className="header_notify_dropdown_list_each--content">
              <h4>New Nike Products Campign</h4>
              <p>Your Application for the new Nike campign accepted for final Scrutiny.</p>
              <span>3 Min ago</span>
            </div>
          </li>
          <li className="header_notify_dropdown_list_each d-flex align-items-center">
            <div className="header_notify_dropdown_list_each--logo">
              <img src="/images/brands-logo/ADI_BLACK.webp"
                className="img-fluid"
                alt="Nike" />
            </div>
            <div className="header_notify_dropdown_list_each--content">
              <h4>Adidas Campign created</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
              <span>56 Min ago</span>
            </div>
          </li>
          <li className="header_notify_dropdown_list_each d-flex align-items-center">
            <div className="header_notify_dropdown_list_each--logo">
              <img src="/images/brand-logo.svg"
                className="img-fluid"
                alt="Nike" />
            </div>
            <div className="header_notify_dropdown_list_each--content">
              <h4>Flynt Security updates</h4>
              <p>Amet quas animi placeat laudantium beatae! Voluptas, impedit voluptate</p>
              <span>1 Day ago</span>
            </div>
          </li>
          <li className="header_notify_dropdown_list_each d-flex align-items-center">
            <div className="header_notify_dropdown_list_each--logo">
              <img src="/images/brands-logo/ADI_BLACK.webp"
                className="img-fluid"
                alt="Nike" />
            </div>
            <div className="header_notify_dropdown_list_each--content">
              <h4>New Nike Products Campign</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
              <span>2 Days ago</span>
            </div>
          </li>
        </ul>
      </Scrollbars>
    </div>
  );
  return (
    <>
      <Header
        className="common_header"
        style={{
          position: 'fixed',
          zIndex: 3,
          width: layoutControl.collapsed ? 'calc(100% - 80px)':'calc(100% - 270px)',
          padding: 0,
          left: layoutControl.collapsed ? '80px':'270px',
          transition: 'all 0.2s',
        }}
      >
        <div className="d-flex align-items-center">
          <div className="col-md-5">
            {React.createElement(layoutControl.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger px-0',
              onClick: toggle,
            })}

          </div>
          <div className="col-md-7 text-right">
            <Tag color={'error'}
              className="mr-4"
              icon={<BsInfoCircle className="mr-1 align-middle" />}>Admin Mode</Tag>
            <Dropdown overlay={menuNotificationDropdown}
              trigger={['click']}>
              <div className="header_user--trigger mr-4">
                <IoNotificationsOutline size={22}/>
              </div>
            </Dropdown>
            <Dropdown overlay={menuUserDropdown}
              trigger={['click']}>
              <div className="header_user--trigger">
                <AiOutlineUser size={22}/>
              </div>
            </Dropdown>
          </div>
        </div>
      </Header>
      {/* @note: drawer for profile */}
      <ProfileComponent visible={profDraw}
        onClose={hideDraw}/>
    </>
  );
};

export default TopHeaderComponent;
